import { isElectron } from "../../libs/roomnew";
import doAuthApple from "./doAppleAuth";
export default class AppleAuth{

    constructor(loginModal){


        this.login = loginModal;
        this.events();
    }

    events(){
        AppleID.auth.init({
            clientId : 'io.kinetx.kino-service-id',
            scope : 'email name',
            redirectURI : isElectron ? `${api.global.app_url}/signin/apple/callback` : `https://${window.location.hostname}/signin/apple/callback`,
            state: new Date().getTime() + "state",
            nonce: new Date().getTime() + "nonce",
            usePopup : true //or false defaults to false
        });
        //Listen for authorization success
        document.addEventListener('AppleIDSignInOnSuccess', (data) => {
            //handle successful response
        });
        //Listen for authorization failures
        document.addEventListener('AppleIDSignInOnFailure', (error) => {
            //handle error.
        });
    };

    async handleSubmit(){
        let a = this;
        // const response = await appleAuthHelpers.signIn({
        // authOptions: {
        //     clientId: 'io.kinetx.kino-service-id',
        //     scope: 'email name',
        //     redirectURI: `https://${window.location.hostname}/signin/apple/callback`,
        //     state: uuidv4(),
        //     nonce: uuidv4(),
        //     usePopup: true,
        // },
        // onError: (error) => console.error(error),
        // // onSuccess: (r) => console.log(r)
        // });
        try {
            const response = await AppleID.auth.signIn()
            if (response) {
                    doAuthApple({idToken: response.authorization.id_token}, 'signin').then((res)=> {
                        console.log(res)
                        if(res.data.success){
                            window.location.reload() //need to put kino id here 
                        }else if (res.data.error){
                            // a.login.generalErrorMessage.html(res.data.message);
                            if($('#signInModalWelcome').hasClass('show')){
                                $('#signInModalWelcomeGeneralError').html('⚠ '+res.data.message);
                            }
                            // alert(res.data.message)
                        }
                
                    }).catch((err)=>{
                        console.log(err)
                        // a.login.generalErrorMessage.html('Something went wrong');
                        if($('#signInModalWelcome').hasClass('show')){
                            $('#signInModalWelcomeGeneralError').html('⚠ Something went wrong');
                        }
                    });
                
            } else {
            console.error('Error performing apple signin.');
            }
        } catch (error) {
            console.error('Error performing apple signin.',error);
        }
        
        
    }
}